var map = {
	"./building/building-50.svg": "7d50",
	"./contract/contract-50.svg": "ce30",
	"./document/document-50.svg": "83b0",
	"./facility/facility-50.svg": "afc2",
	"./role/role-50.svg": "5254"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe25";